import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//COMPONENTS
import OverViewPodRouter from "./overviewPodRouter";
import OrderDetails from "./files/yourOrders/orderDetails";
import OrderPrintingProgress from "./files/yourOrders/printingProgress";

//STYLES
import * as RouterStyles from "./styles/podRouter";

function PodRouter() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = useState(false);
    const [menuSelected, setMenuSelected] = useState("");

    useEffect(() => {
        setIsLoaded(true);
    });

    function changeNavigationSelection(section) {
        setMenuSelected(section);
        console.log(section);
    }

    function handleMenuClick(section) {
        navigate(`./${section}`);
    }

    return (
        <div style={{ height: "100%" }}>
            {isLoaded && (
                <div style={{ height: "100%" }}>
                    <Routes>
                        <Route path={"/overview/*"} element={<OverViewPodRouter />} />
                        <Route path={"/orderDetails/:id"} element={<OrderDetails />} />
                        <Route path={"/orderDetails/:id/printingProgress"} element={<OrderPrintingProgress />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
